module.exports = __webpack_public_path__ + "img/miramar-police-headquarters.23f9de41.jpg";